<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      Card Assign To
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                New Card Assign
              </v-btn>
            </template>

            <v-card>
              <v-form
                @submit.prevent="updateCard()"
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-card-title>
                  <span class="headline">Card Assign to User</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <template>
                          <v-autocomplete
                            :items="employeeData"
                            item-text="employee.full_name"
                            item-key="employee.id"
                            v-model="assign_employee_id"
                            label="Select users"
                            return-object
                          ></v-autocomplete>
                        </template>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="Card Number"
                          hint="Please Scan QR code or Insert Valid Card Number"
                          v-on:change="getCard(card_numbar)"
                          v-model="card_numbar"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-card-title
                          >Added Item: {{ cardList.length }}</v-card-title
                        >
                        <v-card-text>{{ cardList }}</v-card-text>
                      </v-col>
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text type="submit"> Save </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <template>
        <v-autocomplete
          :items="employeeData"
          color="white"
          item-text="employee.full_name"
          item-key="employee.id"
          label="Select Employee"
          v-on:change="getEmployee()"
          v-model="employee_id"
          cols="3"
          sm="3"
          solo
          return-object
          :loading="loadingstatus"
        ></v-autocomplete>
      </template>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        :actions="actions"
        dense
        :loading="loadingstatus"
        mobile-breakpoint="0"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template
              v-slot:activator="{ on, attrs }"
              v-if="item.status == 'inactive' && item.patient_id != null" 
            >
              <v-icon
                @click="cardActive(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-check
              </v-icon>
            </template>
            <span>Acitve & Send SMS</span>
          </v-tooltip>
          
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      dialog: false,
      valid: true,
      card_numbar: null,
      cardList: [],
      search: "",
      employeeData: [],
      employee_id: null,
      assign_employee_id: null,
      loadingstatus: true,
      rules: {
        required: [(value) => !!value || "Required."],
      },
      headers: [
        { text: "Card No", value: "card_no" },
        { text: "Card Type", value: "card_type.name" },
        { text: "Patient ID", value: "patient_id" },

        { text: "Assign For Sell", value: "assign_to.full_name" },
        { text: "Issue Date", value: "issue_date" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions" },
      ],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          func: this.updatePayment,
          icon: "edit",
        },
      ],

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
    this.getEmployementList();
  },
  methods: {
    initialize() {
      let empid = null;
      if (this.employee_id) {
        empid = this.employee_id.employee.id;
      }
      atshq
        .get("card/card-assign?employee_id=" + empid)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.desserts = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getEmployementList() {
      atshq
        .get("hr/employment")
        .then((response) => {
          // JSON responses are automatically parsed.
          this.employeeData = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getEmployee() {
      this.initialize();
    },
    getCard(cardno) {
      if (!cardno) {
        return false;
      }
      if (this.cardList.indexOf(cardno) != -1) {
        this.$noty.error("Already added this item.");
        return false;
      }

      atshq
        .get("card/card/" + cardno)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.loadingstatus = false;
          if (response.data.data != null) {
            this.$noty.success(response.data.messages);

            this.cardList.push(cardno);
            this.card_numbar = null;
          } else {
            this.$noty.error(response.data.messages);
          }
        })
        .catch((e) => {
          this.$noty.error("Oops, something went wrong!");
          this.$noty.error(" " + e);
        });
    },
    updateCard() {
      if (!this.assign_employee_id) {
        this.$noty.error("Please select user");
        return false;
      }
      if (this.cardList.length == 0) {
        this.$noty.error("Please select card");
        return false;
      }
      atshq
        .post("card/card-assign-save", {
          employee: this.assign_employee_id,
          card_list: this.cardList,
        })
        .then((response) => {
          this.loadingstatus = false;
          this.$noty.success(response.data.messages);
          this.dialog = false;
        })
        .catch((e) => {
          this.$noty.error(e.response.data.messages);
          this.$noty.error(" " + e);
        });
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
    cardActive(item) {
      atshq
        .get("card/card-active/" + item.card_no)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.loadingstatus = false;
          this.$noty.success(response.data.messages);
          this.dialog = false;
          item.status='active';
        })
        .catch((e) => {
          // this.errors.push(e);
          this.$noty.error("Oops, something went wrong!");
          this.$noty.error(" " + e);
        });
    },
  },
};
</script>